(function() {
    'use strict';
    
a3_cabin_reports.service("TicketAPIService", TicketAPIService);
    
    /**
    * @memberof CabinReports
    * @ngdoc service
    * @name TicketAPIService
    * @description 
    *  Manages the api calls for the Ticket report system
    * @ngInject
    */
function TicketAPIService($http, $q, apiUrl, localStorageMD5Service, LogService) {
        /**
         * Send Ticket2
         * @memberof TicketAPIService
         * @return {object} promise
         */
           function sendTicket(ticket) {
                var call = $q.defer();
                
                ticket.DeviceData = getStoredValues();
                $http.post(apiUrl +'/ticket', ticket, {'Content-Type': 'application/json'})
                .then(
                    function(responseData) {

                        if(responseData==undefined || responseData.data==undefined || responseData.data.data==undefined)                                                {
                            var err=new Error();
                            err.status=-1;
                            var msg= "ResponseData error while sending a ticket :" + JSON.stringify(responseData);
                            LogService.debug(msg,err)
                            call.reject(err);
                        }else{
                            // return true
                            call.resolve(responseData);
                        }

                    },
                    function(err) {
                            call.reject(err);
                    }
                );
                return call.promise;
            }
    
    
            /**
            * Get all values from localstorage
            * @memberof TicketAPIService
            */
            function getStoredValues() {
                var values = [];
                    var keys = localStorageMD5Service.keys();
                    if (keys) {
                        var key, value, sizeActual, error;
                        for (var i = 0; i < keys.length; i++) {
                            key = keys[i];
                            try {
                                value = localStorageMD5Service.get(key);
                                value = angular.toJson(value);
                                sizeActual = localStorageMD5Service.usedSize(key);
                                error = null;
                            } catch (e) {
                                error = e.message || e.errorMessage;
                            }
                            values.push({
                                key: key,
                                value: value,
                                error: error,
                                size: (value) ? value.length : 0,
                                sizeActual: sizeActual
                            });
                        }
                }
                return values;

            }

            return {
                    sendTicket: sendTicket
            };    
}
    
})();